<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.ir/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
        "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال"
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content: "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content: "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },
    ],
  },
};
</script>

<style>
@import url(./assets/fonts/font.css);
* {
  font-family: IRANSansX, sans-serif !important;
  line-height: 1.5;
}
.v-application {
  font-family: IRANSansX, sans-serif !important;
  line-height: 1.5;
}

html {
  font-size: 15px !important;
}

/* width */
::-webkit-scrollbar {
  width: 4px;
  display: hidden;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
